import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpClient,
} from '@angular/common/http';
import { environment } from '@env/environment';
import { WorkflowDepartmentUpdateDTO } from './../model/workflow-department-update-dto';
import { WriteUsDto } from './../model/write-us-dto';
import { UrlConfigService } from './url-config.service';

@Injectable({
  providedIn: 'root',
})
export class WriteUsService {
  // url = environment.SERVER_URL;

  url: string;
  constructor(private httpClient: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  sendWriteUsMail(writeUsDto: WriteUsDto) {
    return this.httpClient.post(`${this.url}writeUs/send`, writeUsDto);
  }

  getDataList() {
    return this.httpClient.post(`${this.url}getDataList`, 'null');
  }
}
